import { useState } from "react";
import IconFilter from "@/app/(components)/generics/Icons/IconFilter";
import Popover from "@/app/(components)/generics/Popover/Popover";
import PopoverContent from "@/app/(components)/generics/Popover/PopoverContent";
import PopoverTrigger from "@/app/(components)/generics/Popover/PopoverTrigger";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { StandardCallType } from "@/app/types/call/StandardCallType";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./TypeFilter.module.css";

type Props = {
  types: string[];
  value: string | null | undefined;
  onChange: (type: string | null | undefined) => void;
  lang: string;
};

export default function TypeFilter(props: Props) {
  const T = useT();
  const { types, value, onChange } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (type: string | null | undefined) => {
    onChange(type);
    setIsOpen(false);
  };

  const standardTypes = Object.values(StandardCallType);

  return (
    <Popover
      isVisible={isOpen}
      setIsVisible={setIsOpen}
      openAfterClick={true}
      closeWhenClickOutside={true}
      isPortaled={true}
    >
      <PopoverTrigger>
        <span className={UStyles.classNames(styles.trigger, value !== undefined && styles.active)}>
          <IconFilter size={13} />
        </span>
      </PopoverTrigger>

      <PopoverContent position={{ default: { top: "8px", right: "0px" } }}>
        <div className={styles.popoverContent}>
          <div className={styles.list}>
            <div
              className={UStyles.classNames(styles.item, value === undefined && styles.itemActive)}
              onClick={() => handleSelect(undefined)}
            >
              {T(TKey.CALL_ANALYSIS_FILTER_ALL)}
            </div>
            <div
              className={UStyles.classNames(styles.item, value === null && styles.itemActive)}
              onClick={() => handleSelect(null)}
            >
              {T(TKey.PROJECT_MEMBER_UNASSIGNED)}
            </div>
            {types.map((type) => (
              <div
                key={type}
                className={UStyles.classNames(styles.item, value === type && styles.itemActive)}
                onClick={() => handleSelect(type)}
              >
                {standardTypes.includes(type as StandardCallType)
                  ? T(`CALL_TYPE_${type}` as TKey)
                  : type}
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
